import { EyeOutlined } from '@ant-design/icons'
import Plan from '@components/membership/plan/Plan'
import Role from '@components/role/Role'
import { selectAdminById } from '@store/AdminReducer'
import { useAppSelector } from '@store/hooks'
import { selectRolesByIds } from '@store/RoleReducer'
import { Entity } from '@utils/Entities'
import { Space, Tooltip, Typography } from 'antd'
import { FC } from 'react'

const { Text } = Typography

interface Props {
  adminId: number
}

export const AdminSelectRole: FC<Props> = ({ adminId }) => {
  const admin = useAppSelector(selectAdminById(adminId))
  const roles = useAppSelector(selectRolesByIds(admin?.roles || []))

  if (!admin) {
    return <></>
  }

  return (
    <Space orientation="vertical" size={2}>
      <Space>
        {roles.map((role) => (
          <Role.Tag key={role.id} id={role.id} />
        ))}
      </Space>
      {Array.isArray(admin.extraModels) && admin.extraModels.length > 0 && (
        <Tooltip
          title={
            <Space orientation="vertical">
              {admin.extraModels?.map((extraModel) => {
                switch (extraModel.entity) {
                  case Entity.membershipPlan:
                    return (
                      <Plan.Tag key={extraModel.id} id={extraModel.model.id} />
                    )

                  default:
                    return <></>
                }
              })}
            </Space>
          }
        >
          <Text italic type="secondary" style={{ cursor: 'pointer' }}>
            See attached resources <EyeOutlined />
          </Text>
        </Tooltip>
      )}
    </Space>
  )
}

export type AdminSelectRoleType = { SelectRole: typeof AdminSelectRole }
